import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0609da90"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "structures history"
}
const _hoisted_2 = {
  class: "breadcrumb",
  "arial-label": "breadcrumbs"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "structures-body" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Nome", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Criado Por", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Data de Criação", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Última Modificação", -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  ref: "contextmenu",
  class: "context-menu"
}
const _hoisted_12 = { class: "panel" }
const _hoisted_13 = { class: "panel-icon" }
const _hoisted_14 = { class: "panel-icon" }
const _hoisted_15 = { class: "panel-icon" }
const _hoisted_16 = { class: "panel-icon" }
const _hoisted_17 = { class: "panel-icon" }
const _hoisted_18 = { class: "sensor-measure" }
const _hoisted_19 = { class: "sensor-details" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Detalhes", -1))
const _hoisted_21 = { class: "line" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-label" }, "Status", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-label" }, "Data de Criação", -1))
const _hoisted_24 = { class: "line-value" }
const _hoisted_25 = { class: "line" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-label" }, "Criado Por", -1))
const _hoisted_27 = { class: "line-value" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-label" }, "Última Modificação", -1))
const _hoisted_29 = { class: "line-value" }
const _hoisted_30 = { class: "line" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-label" }, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-value" }, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-label" }, "Conectado a", -1))
const _hoisted_34 = { class: "line-value" }
const _hoisted_35 = { class: "button-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_StructureCard = _resolveComponent("StructureCard")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_SensorIcon = _resolveComponent("SensorIcon")!
  const _component_SensorValue = _resolveComponent("SensorValue")!
  const _component_ActiveIcon = _resolveComponent("ActiveIcon")!
  const _component_SensorConnection = _resolveComponent("SensorConnection")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ((_ctx.structures != null))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("nav", _hoisted_2, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navRouteClick()))
                }, "Meu Tenant")
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.history, (structure) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: structure.id
                }, [
                  _createElementVNode("a", {
                    onClick: ($event: any) => (_ctx.navRouteClick(structure))
                  }, _toDisplayString(structure.name), 9, _hoisted_3)
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_PageHeader, { class: "grid list-head" }, {
        default: _withCtx(() => [
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _hoisted_9
        ]),
        _: 1
      }),
      (_ctx.hasReadPermission)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.structures, (structure) => {
              return (_openBlock(), _createBlock(_component_StructureCard, {
                onContextmenu: _withModifiers(($event: any) => (_ctx.openContextMenu($event, structure)), ["prevent"]),
                key: structure.id,
                structure: structure,
                onOnClick: _ctx.goToRoute,
                onOnMapClick: _ctx.goToMap,
                onOnDeleteSensorClick: _ctx.deleteSensor
              }, null, 8, ["onContextmenu", "structure", "onOnClick", "onOnMapClick", "onOnDeleteSensorClick"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("nav", _hoisted_12, [
        (_ctx.assignItemVisible)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "panel-block",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModalConnectToUser(_ctx.selectedStructure)))
            }, [
              _createElementVNode("span", _hoisted_13, [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-link" })
              ]),
              _createTextVNode(" Atribuir ")
            ]))
          : _createCommentVNode("", true),
        (_ctx.isSmartAdmin)
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              class: "panel-block",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModalGateways(_ctx.selectedStructure)))
            }, [
              _createElementVNode("span", _hoisted_14, [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-network-wired" })
              ]),
              _createTextVNode(" Gateways ")
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("a", {
          class: "panel-block",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showStructureDetails(_ctx.selectedStructure)))
        }, [
          _createElementVNode("span", _hoisted_15, [
            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-circle-info" })
          ]),
          _createTextVNode(" Detalhes ")
        ]),
        (_ctx.hasUpdatePermission)
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              class: "panel-block",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editStructure(_ctx.selectedStructure)))
            }, [
              _createElementVNode("span", _hoisted_16, [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-edit" })
              ]),
              _createTextVNode(" Editar ")
            ]))
          : _createCommentVNode("", true),
        (_ctx.hasDeletePermission)
          ? (_openBlock(), _createElementBlock("a", {
              key: 3,
              class: "panel-block",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.deleteStructure && _ctx.deleteStructure(...args)))
            }, [
              _createElementVNode("span", _hoisted_17, [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-trash-can" })
              ]),
              _createTextVNode(" Apagar ")
            ]))
          : _createCommentVNode("", true)
      ])
    ], 512),
    (_ctx.selectedSensor)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          size: "large",
          isActive: _ctx.selectedSensor != null,
          title: _ctx.selectedSensor?.name,
          onCloseModalClick: _ctx.closeModalSensor
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_SensorIcon, {
              type: _ctx.selectedSensor.sensorType || ''
            }, null, 8, ["type"])
          ]),
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_SensorValue, { sensor: _ctx.selectedSensor }, null, 8, ["sensor"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createVNode(_component_ActiveIcon, {
                  class: "line-value",
                  active: true
                }),
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.getLocalDateTime(_ctx.selectedSensor.createdAt)), 1)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.selectedSensor.createdBy), 1),
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.getLocalDateTime(_ctx.selectedSensor.modifiedAt)), 1)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _hoisted_32,
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_component_SensorConnection, { sensor: _ctx.selectedSensor }, null, 8, ["sensor"])
                ])
              ])
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("button", {
                class: "button",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeModalSensor && _ctx.closeModalSensor(...args)))
              }, "Cancelar"),
              _createElementVNode("button", {
                class: "button edit-button",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.editSensor(_ctx.selectedSensor)))
              }, "Editar")
            ])
          ]),
          _: 1
        }, 8, ["isActive", "title", "onCloseModalClick"]))
      : _createCommentVNode("", true)
  ], 64))
}